'use strict';

(function ($, cssua) {
	var DOUTOR = void 0;
	var siteName = 'doutor';
	var clickEvent = cssua.ua.desktop ? 'click' : 'tap';
	var a = 'is-active';
	var v = 'is-visible';
	var h = 'is-hidden';
	var f = 'is-fixed';
	var slideSpeed = 'fast';
	var orientation = cssua.ua.mobile === 'iphone' ? 'orientationchange' : 'resize orientationchange';
	var durationSpeed = 300;

	DOUTOR = {
		va: {
			pathname: location.pathname,
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: $(window).width(),
				height: $(window).height()
			}
		},
		localDecision: function localDecision() {
			var regExp = new RegExp('(test.' + siteName + '.connecty.co.jp|test\\.' + siteName + '\\.com|copre\\.jp|localhost|192\\.168\\.0\\.|192\\.168\\.11\\.|192\\.168\\.1\\.)', 'g');
			return regExp.test(location.hostname);
		},
		localLoading: function localLoading() {
			var _this = this;
			// ローカル環境ならincludeをAjaxで読み込む
			var key = 'inc_';
			var ajaxArray = [];
			var ajaxArrayList = [];
			var i, j;
			var includeClass = document.querySelectorAll('[class*="' + key + '"]');
			var includeClassLen = includeClass.length;

			for (i = 0; i < includeClassLen; i++) {
				var path = includeClass[i].innerHTML.split(' ')[1];
				ajaxArray.push(path);
			}
			var ajaxLen = ajaxArray.length;

			if (ajaxLen > 0) {
				for (i = 0; i < ajaxLen; i++) {
					ajaxArrayList[i] = $.ajax({
						type: 'GET',
						url: ajaxArray[i] + '.html',
						dataType: 'html',
						timeout: 5000
					});
				}
				$.when.apply($, ajaxArrayList).done(function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var regExp = new RegExp(key);

					for (i = 0; i < args.length; i++) {
						var result = args[i];
						var position = $(result[0]).filter(':first').attr('class').split(' ');

						for (j = 0; j < position.length; j++) {
							if (position[j].match(regExp)) {
								position = position[j];
								break;
							}
						}
						$('.' + position).html(result[0]).children().unwrap();

						console.log('Succeeded to read the include file!:', position);
					}
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		nextToggle: function nextToggle() {
			$('body').on(clickEvent, '.js-toggle', function (ev) {
				var $this = $(this);
				var $next = $this.next('.js-toggleBlock');

				if ($next.length > 0) {
					$this.toggleClass(v);
					$next.toggleClass(v);
				}
				ev.stopPropagation();
			});

			// shuttoクラスを持つjs-toggleBlock内のクリックイベントを追加
			$('body').on(clickEvent, '.js-toggleBlock.shutto li', function (ev) {
				var $toggleBlock = $(this).closest('.js-toggleBlock');
				var $toggle = $toggleBlock.prev('.js-toggle');

				setTimeout(function () {
					$toggle.removeClass(v);
					$toggleBlock.removeClass(v);
					ev.stopPropagation();
				}, 200);
			});

			$('html').on(clickEvent, function (ev) {
				var isTarget = $(ev.target).closest('.js-toggleBlock').length;
				var isClose = $(ev.target).closest('.no-close').length;

				if (isClose === 0 && isTarget === 0 && $('.js-toggle').hasClass(v)) {
					$('.js-toggle').removeClass(v);
					$('.js-toggleBlock').removeClass(v);
				}
			});
		},
		nextSlideToggle: function nextSlideToggle() {
			var $switch = $('.js-slide-toggle');

			$switch.on(clickEvent, function () {
				$(this).toggleClass(a);
				$(this).next('.js-slide-toggleBlock').stop().slideToggle(slideSpeed);
			});
		},
		getQuery: function getQuery() {
			var vars = [];
			var hash = null;
			var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			for (var i = 0; i < hashes.length; i++) {
				hash = hashes[i].split('=');
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			}
			return vars;
		},
		easeScroll: function easeScroll() {
			$('a[rel="scroll"]').on(clickEvent, function (event) {
				var speed = 1200;
				if (/#/.test(event.currentTarget.href)) {
					scrollToObject(event.currentTarget.href, speed);
				}
				return false;
			});
			function scrollToObject(_self, _speed) {
				var hash = '#' + _self.split('#')[1];
				var pos = hash === '#pagetop' ? 0 : $(hash).offset().top;
				var map = location.pathname.split('/')[1];

				//				if(hash !== '#pagetop') {
				//					if(DOUTOR.va.window.width < DOUTOR.va.device.sp) {
				//						pos -= 97;
				//					} else if(DOUTOR.va.window.width >= DOUTOR.va.device.sp &&
				//							  DOUTOR.va.window.width < DOUTOR.va.device.desktop) {
				//						pos -= 108;
				//					} else {
				//						if(map === 'employment') {
				//							pos -= 75;
				//						} else {
				//							pos -= 125;
				//						}
				//					}
				//				}

				$('html,body').stop().animate({ scrollTop: pos }, _speed, 'easeOutExpo');
			}
		},
		easeScrollHash: function easeScrollHash() {
			var hash = location.hash;
			var map = location.pathname.split('/')[1];
			if (hash) {
				$(window).on('load', function () {
					$('html, body').css('display', 'none');

					setTimeout(function () {
						$('html, body').css('display', 'block');

						var _hash = '#' + hash.split('#')[1];
						var pos = $(_hash).offset().top;

						// if(DOUTOR.va.window.width < DOUTOR.va.device.sp) {
						// 	pos -= 97;
						// } else if(DOUTOR.va.window.width >= DOUTOR.va.device.sp &&
						// 		  DOUTOR.va.window.width < DOUTOR.va.device.desktop) {
						// 	pos -= 108;
						// } else {
						// 	if(map === 'employment') {
						// 		pos -= 75;
						// 	} else {
						// 		pos -= 125;
						// 	}
						// }
						$('html, body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 0);
				});
			}
		},
		pageTop: function pageTop() {
			var $pagetop = $('.footer-pagetop');

			$(window).scroll(function (e) {
				var $this = $(e.currentTarget);
				var $footer = $('.footer');
				// var footerPos = $footer.offset().top + $footer.height();
				var thisScroll = $this.scrollTop();
				// var pagetopPos = $this.height() + $footer.height() + thisScroll;

				if (thisScroll > '150') {
					$pagetop.addClass(v);
				} else {
					$pagetop.removeClass(v);
				}
				// if(footerPos <= pagetopPos) {
				// 	$pagetop.addClass(f);
				// } else {
				// 	$pagetop.removeClass(f);
				// }
			});
		},
		catchAjaxError: function catchAjaxError(_errorThrown) {
			if (window.ga) {
				window.ga('send', 'event', 'ajaxError', location.href, _errorThrown, 0, true);
			}
		},
		headerMegamenu: function headerMegamenu() {
			var $megamenu = $('.header-megamenu');
			var $menuNav = $('.js-megamenu-nav');
			var $menuNavSwitch = $('.js-megamenu-nav-switch');
			var $megamenuObj = $('.header-megamenu-localNav');
			var $megamenuCloseBtn = $('.header-megamenu-closeBtn');
			var $SPBtn = $('.header-spMenuBtn');
			var megamenuFlg = false;
			var navH = $('.header-table').outerHeight(true);
			var winH = $(window).height();
			var map = location.pathname.split('/')[1];
			var map2 = location.pathname.split('/')[2];

			$menuNav.css('height', 0);

			if (cssua.ua.mobile) {
				megamenuAccordion();
			} else {
				headerCurrent();
			}

			//$megamenuObj.perfectScrollbar();

			// PC:カテゴリボタンホバーで展開 ※Tablet,SPはカテゴリTOPへのリンクのみ
			if (cssua.ua.desktop) {
				$menuNavSwitch.mouseenter(function () {
					var categoryName = $(this).attr('data-category');

					// 開いているメニューを全部閉じる
					$megamenuObj.slideUp(durationSpeed, function () {
						$megamenuObj.find('.header-megamenu-inner').addClass(h);
						megamenuFlg = false;
						// ホバーしたカテゴリのメニューを開く
						$megamenuObj.find('.' + categoryName).removeClass(h);
						megamenuOpen($megamenuObj);
						$(this).addClass(a);
					});
					$menuNavSwitch.removeClass(a);
					headerCurrent();

					$('.header').mouseleave(function () {
						$megamenuObj.slideUp(durationSpeed, function () {
							$megamenuObj.find('.header-megamenu-inner').addClass(h);
							megamenuFlg = false;
						});
						$menuNavSwitch.removeClass(a);
						headerCurrent();
					});
				});
			}

			// [SP] ハンバーガーボタンクリック

			$SPBtn.on(clickEvent, function () {
				var bodyH = $('body').outerHeight(true);

				$SPBtn.attr('src', '/dcs/common/images/ico_hamburger_close.png');
				if (!megamenuFlg) {
					$menuNav.animate({ height: bodyH }, 1000);
					$SPBtn.find('.header-spMenuBtn-hamburger').addClass(a);
					$('.header-megamenu').css('height', bodyH);
					megamenuFlg = true;
				} else {
					$SPBtn.attr('src', '/dcs/common/images/ico_hamburger.png');
					$menuNav.animate({ height: 0 }, { duration: 400, complete: function complete() {
							$menuNav.css('marginLeft', 0);
							$megamenuObj.find('.header-megamenu-inner').addClass(h);
						}
					});
					$megamenu.animate({ height: 0 }, { duration: 400, complete: function complete() {
							$megamenu.css('marginLeft', '100%');
							$megamenuObj.css('display', 'none');
						}
					});
					$(this).find('.header-spMenuBtn-hamburger').removeClass(a);
					megamenuFlg = false;
				}
				return false;
			});

			// 各カテゴリ閉じるボタンクリック
			$megamenuCloseBtn.on(clickEvent, function () {
				if (DOUTOR.va.window.width >= DOUTOR.va.device.sp) {
					$megamenuObj.slideUp(durationSpeed, function () {
						$menuNavSwitch.removeClass(a);
						headerCurrent();
						$megamenuObj.find('.header-megamenu-inner').addClass(h);
					});
					megamenuFlg = false;
				} else {
					if ($('.header-megamenu-inner.search').hasClass(h)) {
						$menuNav.animate({ marginLeft: 0 }, { duration: durationSpeed, complete: function complete() {
								$megamenuObj.find('.header-megamenu-inner').addClass(h);
							}
						});
						$megamenu.animate({ marginLeft: '100%' }, { duration: durationSpeed });
					} else {
						$megamenuObj.find('.header-megamenu-inner').addClass(h);
						$megamenuCloseBtn.removeClass(f);
					}
					megamenuFlg = false;
				}
			});

			function megamenuOpen(_$megamenuObj) {
				_$megamenuObj.not('animate').slideDown(durationSpeed);
				megamenuFlg = true;
				_$megamenuObj.css('max-height', winH - navH - 30);
				//_$megamenuObj.css('max-height', (winH - navH - 30)).perfectScrollbar('update');
			}
			function megamenuAccordion() {
				var $accObj = $('.header-megamenu-list');
				var $accSwitch = $('.js-accordion-switch');
				$accSwitch.on(clickEvent, function () {
					$(this).next($accObj).slideToggle();
					$(this).toggleClass(a);
					return false;
				});
			}
			function headerCurrent() {
				if (map === 'info' || map === 'employment') {
					map = 'company';
				}
				if (map === 'shakaijin' || map === 'ybbjc') {
					map = 'event';
				}
				if (map === 'godo') {
					map = 'lesson';
				}
				$('.header-globalNav-item[data-category="' + map + '"]').addClass(a);
			}
		},
		menuAnchor: function menuAnchor() {
			var menuAnchor = document.querySelectorAll('.js-menuAnchor');
			if (!menuAnchor.length) return;

			$('.js-menuAnchor').each(function (e) {
				$(this).attr('id', 'menu' + (e + 1));
			});
			$('.js-menuAnchor-a').each(function (i) {
				$(this).attr('href', '#menu' + (i + 1));
			});
		},
		menuBottomBanner: function menuBottomBanner() {
			var menuBottom = document.querySelectorAll('.dcs-menu-bottom-item');
			if (!menuBottom.length) return;

			var menuPath = location.pathname.split('/');
			var locPath = menuPath[menuPath.length - 1].split('.');
			var locName = locPath[0];

			if ($('.dcs-products.dcs-products-detail').find('.rt_cf_category_path').length || $('.dcs-menu.dcs-menu-detail').find('.rt_cf_category_path').length) {
				var $detailCat = $('.rt_cf_category_path').text();

				$('.dcs-menu-bottom-item').each(function () {
					var none = $(this).attr('data-menuNav');
					if (none === $detailCat) {
						$(this).addClass(a);
					}
				});
			} else {
				$('.dcs-menu-bottom-item').each(function () {
					var none = $(this).attr('data-menuNav');
					if (none === locName) {
						$(this).addClass(a);
					}
				});
			}
		},
		navSelected: function navSelected() {
			var nowDir = location.pathname.split('/')[2];
			if (location.pathname === '/dcs/service/gift.html') {
				$('.dcs-nav .navmenu [id *= "g-products"]').addClass('selected');
			} else {
				if (nowDir == '' || nowDir == 'index.html') {
					$('.dcs-nav .navmenu [id *= "g-home"]').addClass('selected');
				} else {
					$('.dcs-nav .navmenu [id *= "g-' + nowDir + '"]').addClass('selected');
				}
			}
		},
		facebookWidth: function facebookWidth() {
			var windowWidth = $('.fbblock').width();
			var htmlStr = $('.fb-page').html();
			var timer = null;
			$(window).on('resize', function () {
				var resizedWidth = $('.fbblock').width();
				if (windowWidth != resizedWidth && resizedWidth < 500) {
					clearTimeout(timer);
					timer = setTimeout(function () {
						$('.fb-page').html(htmlStr);
						window.FB.XFBML.parse();
						var windowWidth = $('.fbblock').width();
					}, 500);
				}
			});
		},
		menuTab: function menuTab() {
			if ($('.dcs-menu-catTab').length || $('.dcs-products-menuTab').length) {
				var $menuItem = void 0;
				if ($('.dcs-menu-catTab').length) {
					$menuItem = $('.dcs-menu-catTab-a');
				} else {
					$menuItem = $('.dcs-products-menuTab-a');
				}

				if ($('.dcs-menu.dcs-menu-detail').find('.rt_cf_category_path').length || $('.dcs-products.dcs-products-detail').find('.rt_cf_category_path').length) {
					var $detailCat = $('.rt_cf_category_path').text();
					$menuItem.each(function (index, ele) {
						var $cat = $(ele).attr('data-cat');
						if ($detailCat === $cat) {
							$(ele).addClass(a);
						}
					});
				} else {
					$menuItem.each(function (index, ele) {
						var $cat = $(ele).attr('data-cat');

						if (DOUTOR.va.pathname.indexOf($cat) !== -1) {
							$(ele).addClass(a);
						}
					});
				}

				// SP版でのcurrentの位置を真ん中に持ってくる
				var $spTarget = void 0;
				var $spTargetTab = void 0;
				if ($('.dcs-menu-catTab').length) {
					$spTarget = $('.dcs-menu-catTab-a.is-active');
					$spTargetTab = $('.dcs-menu-catTab');
				} else {
					$spTarget = $('.dcs-products-menuTab-a.is-active');
					$spTargetTab = $('.dcs-products-menuTab');
				}
				$(window).on('resize', function () {
					var winW = $(window).width();
					if (winW < DOUTOR.va.device.sp) {
						$targetW = $spTarget.width(), $centerPos = winW * 0.5 - $targetW * 0.5, leftPos = $spTarget.offset().left;
						$spTargetTab.scrollLeft(leftPos - $centerPos);
					}
				}).resize();
			}
		},
		setShareLinks: function setShareLinks() {
			$('.js-share-item').each(function (idx, ele) {
				var url = encodeURIComponent(document.URL);
				var title = encodeURIComponent(document.title);
				var $this = $(ele);
				var href = $this.attr('href').replace(/#link/ig, url).replace(/#text/ig, title);

				$this.attr('href', href);
			});
		},
		menuDateTime: function menuDateTime() {
			var now = new Date();
			var before2week = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000); //2週間前の日時を取得
			var y = before2week.getFullYear(),
			    m = before2week.getMonth() + 1,
			    d = before2week.getDate();
			var strlenM = String(m).length,
			    strlenD = String(d).length;
			if (strlenM == 1) {
				m = '0' + m;
			}
			if (strlenD == 1) {
				d = '0' + d;
			}
			var ymd = y + '' + m + '' + d;

			var $item = $('.js-datetime');
			$item.each(function () {
				var time = $(this).attr('datetime');
				if (time <= ymd) {
					$(this).removeClass('js-datetime-new');
				}
			});
		},
		campaignBlock: function campaignBlock() {
			if ('.inc_dcs_campaign'.length) {
				var campaignItem = $('.inc_dcs_campaign').find('.campaignList-item');
				if (DOUTOR.va.pathname === '/dcs/' || DOUTOR.va.pathname === '/dcs/index.html') {
					if (campaignItem.length === 0) {
						$('.dcs-idx-campaign').addClass('di_none');
					}
				} else {
					if (campaignItem.length === 0) {
						$('.dcs-menu-campaign').addClass('di_none');
					}
				}
			}
		},
		loadDelayScript: function loadDelayScript() {
			var _this = this;
			_this.nextToggle();
			_this.nextSlideToggle();
			_this.easeScroll();
			_this.easeScrollHash();
			_this.pageTop();
			_this.headerMegamenu();
			_this.menuAnchor();
			_this.menuBottomBanner();
			_this.navSelected();
			_this.facebookWidth();
			_this.menuTab();
			_this.setShareLinks();
			_this.menuDateTime();
			_this.campaignBlock();
		}
	};

	$(function () {
		return DOUTOR.localDecision() ? DOUTOR.localLoading() : DOUTOR.loadDelayScript();
	});
})(window.jQuery, window.cssua);